<!--  -->
<template>
  <div style="margin-bottom: 80px">
    <img style="width: 100%" src="@/../static/img/contact.png" alt="" />
    <img
      style="width: 4.35rem; margin: 0.9rem auto"
      src="@/../static/img/contactTwo.png"
      alt=""
    />

    <div style="margin: 60px auto; width: 6.5rem; height: 4.3rem">
      <!-- <div style="height: 100%" id="container"></div> -->
      <img
        style="width: 100%;height: 100%;"
        src="@/../static/img/address_m.png"
        alt=""
      />
    </div>

    <!-- <div class="content">
      <div style="width: 50%; padding: auto">
        <img
          style="width: 70%; margin: auto"
          src="@/../static/img/contactMap.png"
          alt=""
        />
      </div>

      <div
        style="
          width: 50%;
          text-align: center;
          padding: 0.8rem 1.3rem 1.3rem 1.3rem;
        "
      >
        <el-form
          :rules="rules"
          label-position="left"
          label-width="80px"
          :model="formLabelAlign"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="formLabelAlign.name" placeholder="请输入姓名">
              <i slot="prefix" class="el-input__icon el-icon-s-custom"></i
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="formLabelAlign.region"
              placeholder="请输入手机号"
            >
              <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="留言">
            <el-input
              type="textarea"
              :rows="4"
              v-model="formLabelAlign.type"
              placeholder="感谢您的留言"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="width: 100%; text-align: right">
          <el-button type="primary">提交</el-button>
        </div>
      </div>
    </div> -->
  </div>
</template>



<script>
export default {
  data() {
    return {
      formLabelAlign: {},
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            type: "phone",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },

  components: {},

  computed: {},

  mounted() {
    // 创建地图实例
    // var map = new BMap.Map("container");
    // // 创建点坐标
    // var point = new BMap.Point(113.948331,22.559692);
    // // 初始化地图，设置中心点坐标和地图级别
    // map.centerAndZoom(point, 18);
    // map.addControl(new BMap.NavigationControl()); //平移缩放控件
    // map.addControl(new BMap.ScaleControl()); //比例尺
    // map.addControl(new BMap.OverviewMapControl()); //缩略地图
    // map.addControl(
    //   new BMap.MapTypeControl({ mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP] })
    // ); //地图类型
    // map.setCurrentCity("深圳市"); // 仅当设置城市信息时，MapTypeControl的切换功能才能可用
    // var marker = new BMap.Marker(point);
    // map.addOverlay(marker);
    // 鼠标点击显示位置
    // var geoc = new BMap.Geocoder();
    // map.addEventListener("click", function (e) {
    //   var pt = e.point;
    //   geoc.getLocation(pt, function (rs) {
    //     var addComp = rs.addressComponents;
    //     alert(
    //       addComp.province +
    //         ", " +
    //         addComp.city +
    //         ", " +
    //         addComp.district +
    //         ", " +
    //         addComp.street +
    //         ", " +
    //         addComp.streetNumber
    //     );
    //   });
    // });
  },

  methods: {},
};
</script>
<style rel='stylesheet/less' lang='less' scoped>
.content {
  width: 100%;
  padding: 1rem 1.5rem 0 1.5rem;
  display: flex;
}
.title-label {
  width: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue